export default __webpack_public_path__ + "static/media/bank.33c671dc.svg";